var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutoDl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.299 8.299l-2.735 2.734 2.735 2.735a.774.774 0 11-1.094 1.094L3.892 11.55a.73.73 0 010-1.031l3.313-3.313a.774.774 0 011.094 1.094zM15.41 6.223a.82.82 0 01.3 1.121l-4.65 8.053a.82.82 0 11-1.42-.82l4.649-8.053a.82.82 0 011.12-.3zM17.05 8.299l2.735 2.734-2.735 2.735a.774.774 0 001.094 1.094l3.313-3.313a.73.73 0 000-1.031l-3.313-3.313a.774.774 0 00-1.094 1.094z",
    fill: "#2932E1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    x: 4,
    y: 25,
    width: 18,
    height: 1.5,
    rx: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0h20a3 3 0 013 3v14h0M21 21H3a3 3 0 01-3-3V7h0",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoDl);
export default __webpack_public_path__ + "static/media/AutoDL.2fc20226.svg";
export { ForwardRef as ReactComponent };